function hrs(seconds: number): string {
  const h = seconds / 3600;
  if (h < 1) return `${Math.round(seconds / 60)} min`;
  return `${h.toFixed(1)} h`;
}

/**
 * The member-home identity line's variable segments (Spec 19 decision 3). The
 * caller renders "Member since {date}" (always); each of essays / broadcasts /
 * reading appears only when nonzero — so "0 broadcasts" never shows while no
 * video watch-event writer exists yet. Singular/plural handled.
 */
export function identityLine(stats: {
  essays: number;
  broadcasts: number;
  readingSeconds: number;
}): string[] {
  const out: string[] = [];
  if (stats.essays > 0) out.push(`${stats.essays} ${stats.essays === 1 ? 'essay' : 'essays'}`);
  if (stats.broadcasts > 0) {
    out.push(`${stats.broadcasts} ${stats.broadcasts === 1 ? 'broadcast' : 'broadcasts'}`);
  }
  if (stats.readingSeconds > 0) out.push(`${hrs(stats.readingSeconds)} reading`);
  return out;
}
